import type { ProviderFilter } from '#utils/provider-filter.ts';

import * as React from 'react';
import { useQuery } from '@tanstack/react-query';

import { ProvidersAutocomplete } from '#components/Autocomplete/Providers/ProvidersAutocomplete.tsx';
import { providerDirectory } from '#lib/react-query/queries.ts';
import { allProvidersToken } from '#utils/provider-filter.ts';
import { useFilterAutocomplete } from './use-filter-autocomplete.ts';

export function Provider(props: { defaultValue: ProviderFilter }) {
  // Cache the initial user ids: they seed the control's value once, and a later render passing a
  // fresh array must not re-seed it over what the user has since selected.
  const [defaultIds] = React.useState(() =>
    props.defaultValue === allProvidersToken ? [] : props.defaultValue
  );

  // The picker reads the same directory for its options, so this shares its cache entry rather than
  // hydrating the chips from a request of its own.
  const query = useQuery(providerDirectory);

  const filterAutocomplete = useFilterAutocomplete({
    searchParamKey: 'pId',
    defaultValue: defaultIds,
    emptyValue: allProvidersToken,
    data: query.data,
  });

  // Whether the control is usable yet is the picker's own business — it owns the directory read.
  return <ProvidersAutocomplete {...filterAutocomplete.getAutocompleteProps()} />;
}
